import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Fulfil your legal duty to schools and educational institutions to safeguard your students',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Creating consistent standard reporting across the entire authority ',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Full reporting to Governors ',
                },
                {
                    id: 4,
                    icon: 'fa fa-check',
                    title: 'Review and update throughout the year',
                },
            ]
        }
    }
    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content ">
                                <span className="subheading">50% discount on early purchase</span>
                                <h1>Don't let them fall</h1>
                                <ul>
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                <Link to="#" className="btn btn-main">Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img-175">
                                <img src="assets/images/banner/175-logo.png" alt="" className="img-fluid"/>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>

        );
    }
}

export default Banner;

